import { render, staticRenderFns } from "./ChatButton.vue?vue&type=template&id=3d670c4c"
import script from "./ChatButton.vue?vue&type=script&lang=js"
export * from "./ChatButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d670c4c')) {
      api.createRecord('3d670c4c', component.options)
    } else {
      api.reload('3d670c4c', component.options)
    }
    module.hot.accept("./ChatButton.vue?vue&type=template&id=3d670c4c", function () {
      api.rerender('3d670c4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatButton.vue"
export default component.exports